import { timestampToDate } from 'Utils/Format';
import { isFreeTrial } from 'Utils/Plans';
import { isSheerIdFreePlan } from 'Utils/SheerIdHelpers';
import { isDowngradeSubscription, isUpgradeSubscription } from './Subscriptions';
import { isVAFreePlan } from './VeteransAdvHelpers';

export function getPaymentTotalDue({ subscription, selectedPlan, promoCode }) {
  let totalDueLabel = 'Total due today';
  let dueTimestamp;

  if (isFreeTrial(selectedPlan)) {
    const formattedNextBillingDate = timestampToDate(selectedPlan.defaultPromo.nextBillingDateTime, 2);
    totalDueLabel = `Total due on ${formattedNextBillingDate}`;
    dueTimestamp = selectedPlan.defaultPromo.nextBillingDateTime;
  }
  if (promoCode?.couponCode.length > 0 && promoCode?.isValid) {
    const { nextBillingDateTime, isFlatDiscount } = promoCode;
    if (isFlatDiscount) {
      totalDueLabel = 'Total due today';
    } else {
      const formattedNextBillingDate = timestampToDate(nextBillingDateTime, 2);
      totalDueLabel = `Total due on ${formattedNextBillingDate}`;
      dueTimestamp = nextBillingDateTime;
    }
  }
  if (subscription?.validityTill > Date.now()) {
    const { isTrialistUser, validityTill } = subscription;
    const formattedValidUntilDate = timestampToDate(validityTill, 2);
    const isDowngrade = selectedPlan && isDowngradeSubscription(subscription, selectedPlan);
    const isNonTrialistUpgrade = !isTrialistUser && isUpgradeSubscription(subscription, selectedPlan);
    if (isTrialistUser || isDowngrade) {
      totalDueLabel = `Total due on ${formattedValidUntilDate}`;
      dueTimestamp = validityTill;
    }
    if (isNonTrialistUpgrade) {
      dueTimestamp = new Date();
    }
  }
  // if user's current plan is a free sheer plan
  if (
    selectedPlan &&
    subscription &&
    (isSheerIdFreePlan(subscription.activeSubscriptionId) || isVAFreePlan(subscription.activeSubscriptionId))
  ) {
    totalDueLabel = 'Total due today';
  }
  if (dueTimestamp) {
    // if due date is "today" in the user's timezone, change the label accordingly
    const dueDate = new Date(dueTimestamp);
    const todayDate = new Date();
    dueDate.setHours(0, 0, 0, 0);
    todayDate.setHours(0, 0, 0, 0);
    if (dueDate.getTime() === todayDate.getTime()) {
      totalDueLabel = 'Total due today';
    }
  }
  // if user has selected a free sheer plan
  if (selectedPlan && (isSheerIdFreePlan(selectedPlan.packageID) || isVAFreePlan(selectedPlan.planId))) {
    totalDueLabel = 'Total Due';
  }

  return totalDueLabel;
}
